export const marketKeys = {
  all: ['market'] as const,
  skus: () => [...marketKeys.all, 'skus'] as const,
  sku: (number: number) => [...marketKeys.all, 'sku', number] as const,
  purchases: () => [...marketKeys.all, 'purchases'] as const,
};
